export const baseRoutersMap = [
    // 首页版块
    {
        path: '/',
        redirect: '/index'
    }, {
        path: '/index',
        name: 'index',
        component: () => import('@pages/index/index.vue')
    }, {
        path: '/account/login',
        name: 'login',
        component: () => import('@pages/account/login.vue')
    },
    // example: /share/path_to_/index
    {
        path: '/share/:params',
        name: 'share',
        component: () => import('@pages/index/share.vue')
    }, {
        path: '/index/courseList/:id',
        name: 'indexCourseList',
        component: () => import('@pages/index/courseList.vue')
    }, {
        path: '/discover',
        name: 'discoverPage',
        component: () => import('@pages/discover/index.vue')
    }, {
        path: '/discover/:type',
        name: 'discoverDetail',
        component: () => import('@pages/discover/discover.vue')
    },
    {
        path: '/discoverLatest',
        name: 'discoverLatestPage',
        component: () => import('@pages/discover/latest.vue')
    },

    // article （旧资讯）
    {
        path: '/article',
        name: 'articleIndex',
        component: () => import('@pages/article/index.vue')
    },
    // information （新资讯）  师圈
    {
        path: '/information',
        name: 'informationIndex',
        component: () => import('@pages/information/index.vue')
    }, {
        path: '/information/detail/:id',
        name: 'informationDetail',
        component: () => import('@pages/information/detail.vue')
    },
    {
        path: '/information/user/:id',
        name: 'informationUser',
        component: () => import('@pages/information/user.vue')
    },
    {
        path: '/information/mine/:id',
        name: 'myInformation',
        component: () => import('@pages/information/mine.vue')
    },

    {
        path: '/course',
        name: 'courseList',
        component: () => import('@pages/course/courseList.vue')
    }, {
        path: '/voiceCourse',
        name: 'voiceCourseIndex',
        component: () => import('@comp/voiceCourse/index.vue')
    }, {
        path: '/voiceCourse/detail',
        name: 'voiceCourseDetail',
        component: () => import('@pages/voiceCourse/detail.vue')
    }, {
        path: '/voiceCourse/detail/:id',
        component: () => import('@pages/voiceCourse/detail.vue')
    }, {
        path: '/voiceCourse/detail/:id/promotion/:promotionCode',
        component: () => import('@pages/voiceCourse/detail.vue')
    },
    {
        path: '/voiceCourse/album',
        component: () => import('@pages/voiceCourse/album.vue')
    },

    {
        path: '/voiceCourse/album/:id',
        name: 'albumID',
        component: () => import('@pages/voiceCourse/album.vue')
    },

    {
        path: '/atlas',
        name: 'atlasIndex',
        component: () => import('@/components/atlas/index.vue')
    },
    {
        path: '/atlas/detail/:id',
        name: 'atlasDetail',
        component: () => import('@/components/atlas/atlasDetail.vue')
    },
    {
        path: '/atlas/detail/:id/promotion/:promotionCode',
        component: () => import('@/components/atlas/atlasDetail.vue')
    },
    {
        path: '/atlas/download/:id',
        name: 'atlasDownload',
        component: () => import('@/components/atlas/download.vue')
    },

    {
        path: '/datum/category',
        name: 'datumCategoryIndex',
        component: () => import('@/components/datum/categoryIndex.vue')
    }, {
        path: '/datum/category/tag/:tagId',
        component: () => import('@/components/datum/categoryIndex.vue')
    }, {
        path: '/datum',
        name: 'datumIndex',
        component: () => import('@/components/datum/index.vue')
    }, {
        path: '/datum/search/:keywords',
        component: () => import('@/components/datum/index.vue')
    }, {
        path: '/datum/:tagId',
        component: () => import('@/components/datum/index.vue')
    }, {
        path: '/datum/choiceness',
        name: 'datumChoiceness',
        component: () => import('@/components/datum/choiceness.vue')
    }, {
        path: '/datum/detail/:id',
        name: 'datumDetail',
        component: () => import('@/components/datum/datumDetail.vue')
    }, {
        path: '/datum/detail/:id/promotion/:promotionCode',
        component: () => import('@/components/datum/datumDetail.vue')
    }, {
        path: '/datum/resourceDetail/:id',
        name: 'resourceDetailPage',
        component: () => import('@/components/datum/resourceDetailPage.vue')
    },
    {
        path: '/datum/download/:id',
        name: 'datumDownload',
        component: () => import('@/components/datum/download.vue')
    },

    // 原有专题包页面不用了
    // 后来又用了
    // 主题包（用于早托课程）
    {
        path: '/topicPackage',
        name: 'topicPackageIndex',
        component: () => import('@pages/topicPackage/index.vue')
    }, {
        path: '/topicPackage/:id',
        name: 'topicPackageDetail',
        component: () => import('@pages/topicPackage/detail.vue')
    }, {
        path: '/topicPackage/:id/promotion/:promotionCode',
        component: () => import('@pages/topicPackage/detail.vue')
    }, {
        path: '/topItem/:id',
        name: 'topItem',
        component: () => import('@pages/topicPackage/topItem.vue')
    },
    // 园长商学院
    {
        path: '/topicPackageForKindergartenLeader',
        name: 'topicPackageForKindergartenLeaderIndex',
        component: () => import('@pages/topicPackageForKindergartenLeader/index.vue')
    }, {
        path: '/topicPackageForKindergartenLeader/:id',
        name: 'topicPackageForKindergartenLeaderDetail',
        component: () => import('@pages/topicPackageForKindergartenLeader/detail.vue')
    }, {
        path: '/topicPackageForKindergartenLeader/:id/promotion/:promotionCode',
        component: () => import('@pages/topicPackageForKindergartenLeader/detail.vue')
    },

    {
        path: '/vipCourse',
        name: 'vipCourseIndex',
        component: () => import('@pages/vipCourse/index.vue')
    },

    // 马上学
    {
        path: '/learn',
        name: 'learn',
        component: () => import('@pages/learn/learn.vue')
    },
    // 马上学 - 精品课程 (已废弃)
    // {
    //     path: '/learn/course',
    //     name: 'learncourse',
    //     component: () => import('@pages/learn/learn.vue')
    // },
    {
        path: '/learn/course/:id',
        name: 'courseDetail',
        component: () => import('@pages/course/courseDetail.vue')
    }, {
        path: '/learn/course/:id/promotion/:promotionCode',
        component: () => import('@pages/course/courseDetail.vue')
    },
    // 名师名课
    {
        path: '/learn/courseOfFamousTeacher',
        name: 'courseOfFamousTeacherIndex',
        component: () => import('@pages/learn/learn.vue')
    }, {
        path: '/learn/specialTraining',
        component: () => import('@pages/learn/learn.vue')
    },

    // 精品课程（其实就是所有功能）
    {
        path: '/vodCourse/list',
        name: 'vodCourseList',
        component: () => import('@/components/vodCourse/courseList.vue')
    },
    // 精选课程
    {
        path: '/vodCourse/handpicked',
        name: 'handpickedVodCoursePage',
        component: () => import('@/components/vodCourse/handpickedPage.vue')
    },
    {
        path: '/vodCourse/handpicked/:id',
        component: () => import('@/components/vodCourse/handpickedPage.vue')
    },
    // 专题课程
    {
        path: '/vodCourse/topic',
        name: 'topicVodCoursePage',
        component: () => import('@/components/vodCourse/topicPage.vue')
    },
    // 今日上新课程
    {
        path: '/vodCourse/today',
        name: 'todayVodCoursePage',
        component: () => import('@/components/vodCourse/todayCoursePage.vue')
    },
    // 本月必学课程
    {
        path: '/vodCourse/monthly',
        name: 'monthlyVodCoursePage',
        component: () => import('@/components/vodCourse/monthlyCoursePage.vue')
    },
    // 下月必备课程
    {
        path: '/vodCourse/nextMonth',
        name: 'nextMonthVodCoursePage',
        component: () => import('@/components/vodCourse/nextMonthCoursePage.vue')
    },
    //
    {
        path: '/vodCourse/free',
        name: 'freeVodCoursePage',
        component: () => import('@/components/vodCourse/freeCoursePage.vue')
    },
    // 认证课 (现用名：副业部落，曾用名：学历教资)
    {
        path: '/vodCourse/authenticated',
        name: 'authenticatedCoursePage',
        component: () => import('@/components/vodCourse/authenticatedCoursePage.vue')
    },

    {
        path: '/underlineCourse',
        name: 'underlineCourseIndex',
        component: () => import('@/components/underlineCourse/index.vue')
    },
    {
        path: '/underlineCourse/detail/:id',
        name: 'underlineCourseDetail',
        component: () => import('@/components/underlineCourse/courseDetail.vue')
    }, {
        path: '/underlineCourse/detail/:id/promotion/:promotionCode',
        component: () => import('@/components/underlineCourse/courseDetail.vue')
    },
    {
        path: '/underlineCourse/signup/:id',
        name: 'underlineCourseSignUpPage',
        component: () => import('@/components/underlineCourse/signUpPage.vue')
    }, {
        path: '/underlineCourse/SignUpSuccessPage',
        name: 'underlineCourseSignUpSuccessPage',
        component: () => import('@/components/underlineCourse/signUpSuccessPage.vue')
    }, {
        path: '/underlineCourse/signIn/:id',
        name: 'underlineCourseSignIn',
        component: () => import('@/components/underlineCourse/signIn.vue')
    }, {
        path: '/underlineCourse/myCourse',
        name: 'underlineCourseMyCourse',
        component: () => import('@/components/underlineCourse/my/courseList.vue')
    },
    // 主办方个人中心
    {
        path: '/underlineCourse/sponsor/personalCenter',
        name: 'underlineCourseSponsorPersonalCenter',
        component: () => import('@/components/underlineCourse/sponsor/personalCenter.vue')
    }, {
        path: '/underlineCourse/sponsor/editProfile',
        name: 'underlineCourseSponsorEditProfile',
        component: () => import('@/components/underlineCourse/sponsor/editProfile.vue')
    }, {
        path: '/underlineCourse/sponsor/courseSignUpInfo/:id',
        name: 'underlineCourseSponsorSignUpInfo',
        component: () => import('@/components/underlineCourse/sponsor/courseSignUpInfo.vue')
    },

    //马上学 - 听书
    {
        path: '/learn/listen',
        name: 'learnlisten',
        component: () => import('@pages/learn_secondary/learn.vue')
    },
    //马上学 - 资料
    {
        path: '/learn/learnData',
        name: 'learnlearnData',
        component: () => import('@pages/learn_secondary/learn.vue')
    },
    // 马上学 - 环创
    {
        path: '/learn/envCreation',
        name: 'learnenvCreation',
        component: () => import('@pages/learn_secondary/learn.vue')
    },
    // 马上学 - 听书，精选组合更多
    {
        path: '/learn/listenComp/choicenssMore',
        name: 'choicenssMore',
        component: () => import('@pages/learn_secondary/listenComp/choicenssMore.vue')
    },

    //听单分类详情页
    {
        path: '/learn/listenComp/classifyComp/classifyDetail/:id',
        name: 'classifyDetail',
        component: () => import('@pages/learn_secondary/listenComp/classifyComp/classifyDetail.vue')
    },

    // 直播
    {
        path: '/liveTelecast',
        name: 'liveTelecastIndex',
        component: () => import('@pages/liveTelecast/index.vue')
    }, {
        path: '/liveTelecast/:id',
        name: 'liveTelecastDetail',
        component: () => import('@pages/liveTelecast/detail.vue')
    }, {
        path: '/liveTelecast/:id/promotion/:promotionCode',
        component: () => import('@pages/liveTelecast/detail.vue')
    },

    // 讲师页面
    {
        path: '/lecturer',
        name: 'lecturerListPage',
        component: () => import('@/components/lecturer/listPage.vue')
    },
    {
        path: '/lecturer/:id',
        name: 'lecturerDetailPage',
        component: () => import('@/components/lecturer/detailPage.vue')
    },



    // VIP
    {
        path: '/vip',
        name: 'vipIndex',
        component: () => import('@pages/vip/index.vue')
    },
    {
        path: '/vip/:type', // super | course_vod | datum | atlas_vip
        component: () => import('@pages/vip/index.vue')
    },
    {
        path: '/vip/:type/promotion/:promotionCode', // type: super | course_vod | datum
        component: () => import('@pages/vip/index.vue')
    },
    {
        path: '/vipOpenSuccess',
        component: () => import('@pages/vip/openSuccess.vue')
    },
    {
        path: '/vipOpenSuccess/:id',   // id : order ID
        name: 'vipOpenSuccess',
        component: () => import('@pages/vip/openSuccess.vue')
    }, {
        path: '/courseVip',
        name: 'courseVip',
        component: () => import('@pages/vip/courseVip.vue')
    }, {
        path: '/openSuccessForCourseVip',
        name: 'openSuccessForCourseVip',
        component: () => import('@pages/vip/openSuccessForCourseVip.vue')
    },{
        path: '/me/courseVip',
        name: 'courseVipPersonalCenter',
        component: () => import('@pages/vip/courseVipPersonalCenter.vue')
    },{
        path: '/me/kindergartenVip',
        component: () => import('@pages/vip/kindergartenVipPersonalCenter.vue')
    },

    // 园所VIP
    {
        path: '/kindergartenVip/personalCenter',
        name: 'kindergartenVipPersonalCenter',
        component: () => import('@comp/kindergartenVip/personalCenter.vue')
    },

    // 人才市场（人力资源）
    {
        path: '/humanResources',
        name: 'humanResourcesIndex',
        component: () => import('@comp/humanResources')
    },
    //个人中心
    {
        path: '/me',
        name: 'me',
        component: () => import('@pages/me/me.vue')
    },

    {
        path: '/me/myFavorite',
        name: 'myFavorite',
        component: () => import('@pages/me/myFavorite.vue')
    },
    {
        path: '/me/setting',
        name: 'setting',
        component: () => import('@pages/me/setting.vue')
    }, {
        path: '/me/myProfile',
        name: 'myProfile',
        component: () => import('@pages/me/myProfile.vue')
    },
    {
        path: '/me/bindPhone',
        name: 'bindPhone',
        component: () => import('@pages/me/bindPhone.vue')
    },{
        path: '/me/phoneBindingStatus',
        name: 'phoneBindingStatus',
        component: () => import('@pages/me/phoneBindingStatus.vue')
    },
    {
        path: '/me/idCardAuth',
        name: 'idCardAuth',
        component: () => import('@pages/me/idCardAuth.vue')
    },
    // 账号与安全
    {
        path: '/me/account',
        name: 'account',
        component: () => import('@pages/me/account.vue')
    }, {
        path: '/me/removeAccount',
        name: 'removeAccount',
        component: () => import('@pages/me/removeAccount.vue')
    },

    {
        path: '/shopping/myAddress',
        name: 'myAddressList',
        component: () => import('@pages/me/shopping/myAddressList.vue')
    },{
        path: '/shopping/editAddress',
        name: 'editAddress',
        component: () => import('@pages/me/shopping/editAddress.vue')
    },{
        path: '/shopping/editAddress/:id',
        component: () => import('@pages/me/shopping/editAddress.vue')
    },

    //学习清单更多
    {
        path: '/me/meComp/learnListMore',
        name: 'learnListMore',
        component: () => import('@pages/me/meComp/learnListMoreNew.vue')
    },

    //学习清单更多
    {
        path: '/me/invite',
        name: 'invite',
        component: () => import('@pages/me/invite.vue')
    },

    // 消息中心
    {
        path: '/me/message',
        name: 'meMessageIndex',
        component: () => import('@pages/me/message/index.vue')
    }, {
        path: '/me/message/list',
        name: 'meMessageList',
        component: () => import('@pages/me/message/messageList.vue')
    }, {
        path: '/me/message/list/:type',
        component: () => import('@pages/me/message/messageList.vue')
    },
    {
        path: '/me/message/dynamicDetail',
        name: 'dynamicDetail',
        component: () => import('@pages/me/message/dynamicDetail.vue')
    }, {
        path: '/me/message/dynamicDetail/:id',
        component: () => import('@pages/me/message/dynamicDetail.vue')
    },

    // 信息登记
    {
        path: '/me/registerInformation',
        name : 'registerInformation',
        component: () => import('@pages/registerInformation/index.vue')
    },
    {
        path: '/me/registerInformation/add',
        name : 'registerInformationAdd',
        component: () => import('@pages/registerInformation/edit.vue')
    },
    {
        path: '/me/registerInformation/add/promotion/:promotionCode',
        component: () => import('@pages/registerInformation/edit.vue')
    },
    {
        path: '/me/registerInformation/edit/:id',
        name : 'registerInformationEdit',
        component: () => import('@pages/registerInformation/edit.vue')
    },
    {
        path: '/me/registerInformation/detail/:id',
        name : 'registerInformationDetail',
        component: () => import('@pages/registerInformation/detail.vue')
    },
    {
        path: '/me/registerInformation/success',
        name : 'registerInformationSuccess',
        component: () => import('@pages/registerInformation/success.vue')
    },

    //卡劵
    {
        path: '/cardroll',
        name: 'cardroll',
        component: () => import('@pages/me/cardroll.vue')
    },

    //订单
    {
        path: '/orderForm',
        name: 'orderForm',
        component: () => import('@pages/me/orderForm.vue')
    },

    //考试
    {
        path: '/examination',
        name: 'examination',
        component: () => import('@pages/me/examination.vue')
    },

    //钱包
    {
        path: '/wallet',
        name: 'wallet',
        component: () => import('@pages/me/wallet.vue')
    },

    //学分
    {
        path: '/integral',
        name: 'integral',
        component: () => import('@pages/me/integral.vue')
    },
    {
        path: '/integralComp/integralDetail',
        name: 'integralDetail',
        component: () => import('@pages/me/integralComp/integralDetail.vue')
    },

    // 学分领取
    // {
    //     path: '/integral/receiveIntegralAfterPay/:id',
    //     name: 'receiveIntegralAfterPay',
    //     component: () => import('@pages/integral/receiveIntegralAfterPay.vue')
    // },

    //签到
    {
        path: '/signIn',
        name: 'signIn',
        component: () => import('@pages/me/signIn.vue')
    },

    //抽奖
    {
        path: '/drawAward/:id',
        name: 'drawAward',
        component: () => import('@/components/lotto/drawAward.vue')
    },

    //抽奖记录
    {
        path: '/awardComp/awardDetail/:id',
        name: 'awardDetail',
        component: () => import('@/components/lotto/awardComp/awardDetail.vue')
    },
    //二级运营

    // -旧秒杀主页（已废弃）
    {
        path: '/operationMain/seckill',
        name: 'operationMainseckill',
        component: () => import('@pages/twoOperation/operationMain.vue'),
    },

    // -秒杀详情（已废弃）
    {
        path: '/operationMain/seckill/:id',
        name: 'secKillDetail',
        component: () => import('@pages/twoOperation/courseSecondKillDetail.vue'),
    },

    // -秒杀主页
    {
        path: '/secondKill',
        name: 'secondKillIndex',
        component: () => import('@comp/secondKill/index.vue'),
    },
    {
        path: '/secondKill/datum/:id',
        name: 'secondKillDatumDetail',
        component: () => import('@comp/secondKill/datumDetail.vue'),
    },

    // -签到
    {
        path: '/operationMain/integral',
        name: 'operationMainintegral',
        component: () => import('@pages/twoOperation/operationForIntgral.vue'),

    },

    // -9.9好课
    {
        path: '/operationMain/goodLesson',
        name: 'operationMaingoodLesson',
        component: () => import('@pages/twoOperation/operationMain.vue'),
    },

    // 免费课
    {
        path: '/operationMain/freeCourse',
        name: 'operationMainfreeCourse',
        component: () => import('@pages/twoOperation/operationMain.vue'),
    },

    //免费7节课
    {
        path: '/freeLearn',
        name: 'freeLearn',
        component: () => import('@pages/freeLearn/index.vue'),
    },


    //首页推广板块
    //合作 / 特色课程
    {
        path: '/popularize/:type',
        component: () => import('@pages/popularize/popularize.vue'),
    },
    {
        path: '/popularize',
        name: 'popularize',
        component: () => import('@pages/popularize/popularize.vue'),
    },


    {
        path: '/cooperation/:type/',
        component: () => import('@pages/popularize/cooperation/article.vue'),
    },

    {
        path: '/cooperation',
        name: 'cooperation',
        component: () => import('@pages/popularize/cooperation/article.vue'),
    },

    // 提升
    {
        path: '/promote/:type/',
        component: () => import('@pages/popularize/promote/article.vue'),
    },
    //招生
    {
        path: '/recruit/students',
        component: () => import('@pages/popularize/recruit/article.vue'),
    },


    {
        path: '/promote',
        name: 'promote',
        component: () => import('@pages/popularize/promote/article.vue'),
    },
    // 促销页面
    {
        path: '/salesPromotion/activity/:id',
        name: 'activity',
        component: () => import('@pages/salesPromotion/activity.vue'),
    },
    { // VIP 体验
        path: '/salesPromotion/trialVip',
        name: 'trialVip',
        component: () => import('@pages/salesPromotion/trialVip.vue'),
    },
    { //  优惠券领取
        path: '/salesPromotion/couponDraw/:id',
        name: 'couponDraw',
        component: () => import('@pages/salesPromotion/couponDraw.vue'),
    },
    { //  2021 跨年活动
        path: '/salesPromotion/newYear2021',
        name: 'newYear2021',
        component: () => import('@pages/salesPromotion/newYear2021.vue'),
    },
    { //  新课程预订 下月必备 提前购
        path: '/course/coursePrepay',
        name: 'newCoursePrepayList',
        component: () => import('@pages/course/newCoursePrepayList.vue'),
    },
    { //  课程预订
        path: '/course/coursePrepay/:id',
        name: 'coursePrepay',
        component: () => import('@pages/course/coursePrepay.vue'),
    }, {
        path: '/course/coursePrepay/:id/promotion/:promotionCode',
        component: () => import('@pages/course/coursePrepay.vue'),
    }, {
        path: '/freeLearn',
        component: () => import('@pages/freeLearn/index.vue'),
    }, {
        path: '/freeLearn/:categoryId/:id',
        component: () => import('@pages/freeLearn/index.vue'),
    },

    // 新人福利领取页
    {
        path: '/newPeople/giftReceive/:id',
        name: 'newPeopleGiftReceive',
        component: () => import('@pages/newPeople/giftReceive.vue'),
    },
    // 新人福利领取成功
    {
        path: '/newPeople/giftReceiveSuccess/:id',
        name: 'newPeopleGiftReceiveSuccess',
        component: () => import('@pages/newPeople/giftReceiveSuccess.vue'),
    },
    // 新人福利领取成功后的必学页面
    {
        path: '/newPeople/learnRequired/:id',
        name: 'newPeopleLearnRequired',
        component: () => import('@pages/newPeople/learnRequired.vue'),
    },


    // 园区页面
    {
        path: '/parkDetail/:id',
        name: 'parkDetail',
        component: () => import('@comp/humanResources/parkDetail.vue')
    }, {
        path: '/parkDetail/:id/promotion/:promotionCode',
        component: () => import('@comp/humanResources/parkDetail.vue')
    },

    // 我的园区页面
    {
        path: '/myPark',
        name: 'myPark',
        component: () => import('@comp/humanResources/myPark.vue')
    }, {
        path: '/myPark/edit',
        name: 'editMyParkInfo',
        component: () => import('@comp/humanResources/editMyParkInfo.vue')
    }, {
        path: '/myPark/job/edit',
        name: 'editJob',
        component: () => import('@comp/humanResources/editJob.vue')
    },

    // 授课老师个人中心
    {
        path: '/teacher/personalCenter',
        name: 'teacherPersonalCenter',
        component: () => import('@comp/teacher/personalCenter.vue')
    },

    //投票页面
    {
        path: '/vote',
        name: 'vote',
        component: () => import('@pages/vote/index.vue')
    },
    {
        path: '/vote/rules',
        name: 'rules',
        component: () => import('@pages/vote/rules.vue')
    },
    {
        path: '/vote/signUp',
        name: 'voteSignUp',
        component: () => import('@pages/vote/signUp.vue')
    },

    // 其他单页
    {
        path: '/error',
        component: () => import('@pages/notFound/error.vue'),
    },
    {
        path: '/defaultPage',
        component: () => import('@pages/defaultPage.vue'),
    },
    {
        path: '/demo/animation',
        component: () => import('@/components/demo/animation.vue'),
    },
    {
        path: '/demo/course',
        component: () => import('@/components/demo/course.vue'),
    },
    {
        path: '/demo/roulette/:id',
        component: () => import('@/components/demo/roulette.vue'),
    },
    {
        path: '/demo/rouletteDeluxe',
        component: () => import('@/components/demo/rouletteDeluxe.vue'),
    },
    {
        path: '/demo/location',
        component: () => import('@/components/demo/location.vue'),
    },
    {
        path: '/template/subPageList',
        component: () => import('@/pages/subPageListTemplate.vue'),
    }, {
        path: '/template/subPage',
        component: () => import('@/pages/subPageTemplate.vue'),
    }, {
        path: '/template/formPage',
        component: () => import('@/pages/formPageTemplate.vue'),
    }, {
        path: '/template/requestSubmitSuccess',
        component: () => import('@/pages/requestSubmitSuccessTemplate.vue'),
    },

    {
        path: '/tool/componentLibrary',
        component: () => import('@pages/tool/componentLibrary.vue'),
    },
    {
        path: '/questionnaire',
        component: () => import('@pages/questionnaire/questionnaire.vue'),
    },

    // recharge
    {
        path: '/recharge/limitOfDownload',
        component: () => import('@comp/recharge/rechargeLimitOfDownload.vue'),
    }, {
        path: '/recharge/limitOfDownload/promotion/:promotionCode',
        component: () => import('@comp/recharge/rechargeLimitOfDownload.vue'),
    }, {
        path: '/recharge/history',
        component: () => import('@comp/recharge/history.vue'),
    },

    // help
    {
        path: '/help/rechargeLicense',
        component: () => import('@comp/help/rechargeLicense.vue'),
    }, {
        path: '/help/feedback',
        name: 'feedback',
        component: () => import('@comp/help/feedback.vue'),
    },
    // 协议
    {
        path: '/help/agreement/:type',
        name: 'agreement',
        component: () => import('@comp/help/agreement.vue'),
    },{
        path: '/help/agreement_for_biz/:bizType/:bizId',
        name: 'agreement_for_biz',
        component: () => import('@comp/help/agreement_for_biz.vue'),
    },
    // 指南
    {
        path: '/help/guide',
        name: 'guide',
        component: () => import('@comp/help/guide.vue'),
    },


    // app
    {
        path: '/app/download',
        name: 'appDownload',
        component: () => import('@/pages/app/download.vue'),
    },

    // business cooperate
    {
        path: '/business/cooperate',
        name: 'businessCooperate',
        component: () => import('@/pages/business/cooperate.vue'),
    }, {
        path: '/business/cooperate_for_ad',
        name: 'businessCooperateForAd',
        component: () => import('@/pages/business/cooperate_for_ad.vue'),
    },

    // 首页搜索框跳转
    {
        path: '/search',
        component: () => import('@comp/search/search.vue'),
        name: 'search'
    },

    {
        path: '/thirdService/purchaseDetail/:id',
        component: () => import('@comp/thirdService/purchaseDetail.vue'),
        name: 'thirdServicePurchaseDetail'
    }, {
        path: '/thirdService/purchaseDetail/:id/promotion/:promotionCode',
        component: () => import('@comp/thirdService/purchaseDetail.vue'),
    },
    {
        path: '/thirdService/smallToolVipOpenSuccess',
        component: () => import('@comp/thirdService/smallToolVipOpenSuccess.vue'),
        name: 'smallToolVipOpenSuccess'
    },

    // 主办方认证
    {
        path: '/auth/sponsorAuth',
        component: () => import('@pages/auth/sponsorAuth.vue'),
        name: 'sponsorAuth'
    }, {
        path: '/auth/sponsorAuthForm',
        component: () => import('@pages/auth/sponsorAuthForm.vue'),
        name: 'sponsorAuthForm'
    }, {
        path: '/auth/sponsorAuthHelp',
        component: () => import('@pages/auth/sponsorAuthHelp.vue'),
        name: 'sponsorAuthHelp'
    }, {
        path: '/auth/sponsorAuthSubmitSuccess',
        component: () => import('@pages/auth/sponsorAuthSubmitSuccess.vue'),
        name: 'sponsorAuthSubmitSuccess'
    },

    // 幼儿园园所认证
    {
        path: '/auth/kindergartenAuth',
        component: () => import('@pages/auth/kindergartenAuth.vue'),
        name: 'kindergartenAuth'
    }, {
        path: '/auth/kindergartenAuthForm',
        component: () => import('@pages/auth/kindergartenAuthForm.vue'),
        name: 'kindergartenAuthForm'
    }, {
        path: '/auth/kindergartenAuthHelp',
        component: () => import('@pages/auth/kindergartenAuthHelp.vue'),
        name: 'kindergartenAuthHelp'
    }, {
        path: '/auth/kindergartenAuthSubmitSuccess',
        component: () => import('@pages/auth/kindergartenAuthSubmitSuccess.vue'),
        name: 'kindergartenAuthSubmitSuccess'
    },

    // 代理商（合伙人）认证
    {
        path: '/auth/agencyAuth',
        component: () => import('@pages/auth/agencyAuth.vue'),
        name: 'agencyAuth'
    }, {
        path: '/auth/agencyAuthForm',
        component: () => import('@pages/auth/agencyAuthForm.vue'),
        name: 'agencyAuthForm'
    }, {
        path: '/auth/agencyAuthHelp',
        component: () => import('@pages/auth/agencyAuthHelp.vue'),
        name: 'agencyAuthHelp'
    }, {
        path: '/auth/agencyAuthSubmitSuccess',
        component: () => import('@pages/auth/agencyAuthSubmitSuccess.vue'),
        name: 'agencyAuthSubmitSuccess'
    },

    // 分销员认证
    {
        path: '/auth/distributorAuth',
        component: () => import('@pages/auth/distributorAuth.vue'),
        name: 'distributorAuth'
    },{
        path: '/auth/distributorAuth/:roleId',
        component: () => import('@pages/auth/distributorAuth.vue')
    },
    {
        path: '/auth/shixunVip',
        component: () => import('@pages/me/meComp/shixunVip.vue'),
        name: 'shixunVip'

    },
    {
        path: '/auth/distributorAuth/promotion/:promotionCode',
        component: () => import('@pages/auth/distributorAuth.vue')
    }, {
        path: '/auth/distributorAuthForm',
        component: () => import('@pages/auth/distributorAuthForm.vue'),
        name: 'distributorAuthForm'
    }, {
        path: '/auth/distributorAuthForm/:code',
        component: () => import('@pages/auth/distributorAuthForm.vue')
    }, {
        path: '/auth/distributorAuthHelp',
        component: () => import('@pages/auth/distributorAuthHelp.vue'),
        name: 'distributorAuthHelp'
    }, {
        path: '/auth/distributorAuthSubmitSuccess',
        component: () => import('@pages/auth/distributorAuthSubmitSuccess.vue'),
        name: 'distributorAuthSubmitSuccess'
    }, {
        path: '/auth/distributorOpen',
        component: () => import('@pages/auth/distributorOpen.vue'),
        name: 'distributorOpen'
    }, {
        path: '/auth/distributorOpenSuccess',
        component: () => import('@pages/auth/distributorOpenSuccess.vue'),
        name: 'distributorOpenSuccess'
    },

    // 授权老师认证
    {
        path: '/auth/teacherAuth',
        component: () => import('@pages/auth/teacherAuth.vue'),
        name: 'teacherAuth'
    }, {
        path: '/auth/teacherAuthForm',
        component: () => import('@pages/auth/teacherAuthForm.vue'),
        name: 'teacherAuthForm'
    }, {
        path: '/auth/teacherAuthHelp',
        component: () => import('@pages/auth/teacherAuthHelp.vue'),
        name: 'teacherAuthHelp'
    }, {
        path: '/auth/teacherAuthSubmitSuccess',
        component: () => import('@pages/auth/teacherAuthSubmitSuccess.vue'),
        name: 'teacherAuthSubmitSuccess'
    },

    // 代理商个人中心
    {
        path: '/agency/personalCenter',
        name: 'agencyPersonalCenter',
        component: () => import('@comp/agency/personalCenter.vue')
    },
    {
        path: '/agency/memberList',
        name: 'agencyMemberList',
        component: () => import('@comp/agency/memberList.vue')
    },
    {
        path: '/agency/resource',
        name: 'agencyResource',
        component: () => import('@comp/agency/resource.vue')
    },
    {
        path: '/agency/productActivation',
        name: 'agencyProductActivation',
        component: () => import('@comp/agency/productActivation.vue')
    },
    {
        path: '/agency/recharge',
        name: 'agencyRecharge',
        component: () => import('@comp/agency/recharge.vue')
    },{
        path: '/agency/incomeDetail',
        name: 'agencyIncomeDetail',
        component: () => import('@comp/agency/incomeDetail.vue')
    },{
        path: '/agency/logList',
        name: 'agencyLogList',
        component: () => import('@comp/agency/logList.vue')
    },

    // 分销员个人中心
    {
        path: '/distributor/personalCenter',
        name: 'distributorPersonalCenter',
        component: () => import('@comp/distributor/personalCenter.vue')
    },
    {
        path: '/distributor/incomeManage',
        name: 'distributorIncomeManage',
        component: () => import('@comp/distributor/incomeManage.vue')
    },
    {
        path: '/distributor/incomeManage/incomeDetailList',
        name: 'distributionIncomeDetailList',
        component: () => import('@comp/distributor/incomeDetailList.vue')
    },
    {
        path: '/distributor/withdrawCash',
        name: 'distributorWithdrawCash',
        component: () => import('@comp/distributor/withdrawCash.vue')
    }, {
        path: '/distributor/withdrawCash/requestSubmitSuccess',
        name: 'distributorWithDrawRequestSubmitSuccess',
        component: () => import('@comp/distributor/withDrawRequestSubmitSuccess.vue')
    },
    {
        path: '/distributor/withdrawCashToBankCard',
        name: 'distributorWithdrawCashToBankCard',
        component: () => import('@comp/distributor/withdrawCashToBankCard.vue')
    },
    {
        path: '/distributor/withdrawRequestList',
        name: 'distributorWithdrawRequestList',
        component: () => import('@comp/distributor/withdrawRequestList.vue')
    }, {
        path: '/distributor/resource',
        name: 'distributorResource',
        component: () => import('@comp/distributor/resource.vue')
    },{
        path: '/distributor/teamMembers',
        name: 'distributorTeamMembers',
        component: () => import('@comp/distributor/teamMembers.vue')
    },

    // 实物售卖
    {
        path: '/shop/goodsList',
        name: 'shopGoodsList',
        component: () => import('@comp/shop/goodsList.vue')
    },
    {
        path: '/shop/goodsList/type/:typeId',
        component: () => import('@comp/shop/goodsList.vue')
    },
    {
        path: '/shop/goodsDetail/:id',
        name: 'shopGoodsDetail',
        component: () => import('@comp/shop/goodsDetail.vue')
    }, {
        path: '/shop/goodsDetail/:id/promotion/:promotionCode',
        component: () => import('@comp/shop/goodsDetail.vue')
    },

    // 职业技能 栏目
    {
        path: '/zhiye_jineng',
        name: 'zhiye_jineng',
        component: () => import('@pages/zhiye_jineng/index.vue')
    },
    {
        path: '/zhiye_jineng/list/:id',
        name: 'zhiye_jineng_list',
        component: () => import('@pages/zhiye_jineng/list.vue')
    },


]
